import type {Converter, ConverterArguments, HeightConverterKey} from '../types'
import {getManifestInitialSize, getParentHeight, getStaleMeasurements, getValue} from '../utils'
import {em, px, rem, siteWidthPercentage, spx, unset, vh, vw} from './common'
import {autoHeight} from './autoHeight'
import {DEFAULT_HEIGHT} from '../constants'
import type {DataModelExtensionAPI} from '../../../dataModel/dataModel'
import type {ManifestExtensionAPI} from '../../../builderComponents/manifest'

export const convertHeightToPx: Record<HeightConverterKey, Converter> = {
    px,
    spx,
    em,
    rem,
    auto: autoHeight,
    vw,
    vh,
    aspectRatio, // depends on width
    percentage, // depends on parent height
    unset,
    siteWidthPercentage,
    MinMaxSize: minMaxSize,
    fit: getDefaultHeight,
    maxContent: getDefaultHeight,
    minContent: getDefaultHeight,
    fr: getDefaultHeight,
    Repeat: getDefaultHeight,
    Calc: getDefaultHeight,
    CalcFormula: getDefaultHeight,
    SystemVariable: getDefaultHeight
}

function percentage(converterArguments: ConverterArguments) {
    const parentHeight = getParentHeight(converterArguments)
    return (converterArguments.value / 100) * parentHeight
}

function aspectRatio(converterArgumnets: ConverterArguments) {
    const {measurementsMapAPI, compRef, calculate, value} = converterArgumnets
    const {get} = measurementsMapAPI
    calculate.width(converterArgumnets)

    return value * get.width(compRef)
}

function minMaxSize(converterArguments: ConverterArguments): number {
    const {min, max} = converterArguments
    const minPx =
        min &&
        convertHeightToPx[min.type]({
            ...converterArguments,
            value: getValue(min)
        })
    if (minPx) return minPx

    const maxPx =
        max &&
        convertHeightToPx[max.type]({
            ...converterArguments,
            value: getValue(max)
        })
    return maxPx ?? DEFAULT_HEIGHT
}

export function getDefaultHeight({extensionAPI, compRef}: ConverterArguments) {
    const {dataModel, manifest} = extensionAPI as DataModelExtensionAPI & ManifestExtensionAPI

    const staleMeasurements = getStaleMeasurements(dataModel, compRef)
    const manifestInitialSize = getManifestInitialSize(manifest, compRef)

    return staleMeasurements?.height ?? manifestInitialSize?.height?.pixels ?? DEFAULT_HEIGHT
}
